<template>
    <v-container class="pa-0">
        <add-view v-if="show_add_view"></add-view>
        <department-students v-if="show_table_view"></department-students>
    </v-container>
</template>

<script>
    import AddView from "@/components/add/AddView";
    import DepartmentStudents from './DepartmentStudents'

    export default {

        components: {
            AddView,
            DepartmentStudents
        },

        created: function () {
            let table = 'odjeljenje';
            this.$store.commit('setTable', table);

            this.show_add_view = this.$route.matched[0].name === 'EditDepartmentStudents';
            this.show_table_view = this.$route.matched[0].name === 'SingleDepartment';
        },

        data: function () {
            return {
                show_table_view: false
            };
        }
    }
</script>